export default "__VITE_ASSET__BfyRxDBE__"